import { createStore, combineReducers, compose, applyMiddleware } from "redux";
import { persistStore, persistReducer, createTransform } from "redux-persist";
import storage from "redux-persist/lib/storage";
import thunk from "redux-thunk";

import notification from "./notification";
import auth from "./auth";
import propertyinfo from "./propertyinfo";
import tenants from "./tenants";
import selectedPeriods from "./selectedPeriods";
import selectCSC from "./selectCSC";
import selectSystemType from "./selectSystem";
import profile from "./profile";

const composeEnhancers =
  typeof window === "object" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({})
    : compose;

const rootReducer = combineReducers({
  selectedPeriods,
  tenants,
  profile,
  propertyinfo,
  notification,
  auth,
  selectCSC,
  selectSystemType,
});

// Persisting Javascript Date objects
// https://github.com/rt2zz/redux-persist/issues/82#issuecomment-468265789

const persistConfig = {
  key: "app",
  storage,
  transforms: [
    createTransform(JSON.stringify, (toRehydrate) =>
      JSON.parse(toRehydrate, (key, value) =>
        typeof value === "string" && value.match(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/)
          ? new Date(value)
          : value
      )
    ),
  ],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = createStore(persistedReducer, undefined, composeEnhancers(applyMiddleware(thunk)));

export const persistor = persistStore(store);

export default store;
